import {User} from "./User";
import {GraphData} from "../components/stats/userStats/graphBestScore/graph";


export interface CustomGraphData extends GraphData {
    scoreUser: number,
    totalPlayers: number,
    avgWords: number,
    topWords: number
}

export class UserWithStats extends User {
    best: number
    dateBest: Date
    accuracy: number
    mean: number
    
    totalGames?: number
    totalWords?: number
    globalRank?: number
    countryRank?: number
    bestScoresByDay?: GraphData[]

    // fastaily stats
    positions?: CustomGraphData[]
    avgPosition?: number
    rank: number

    constructor(obj: any) {
        super(obj)
        this.best = obj.best
        this.dateBest = new Date(obj.dateBest)
        this.accuracy = obj.accuracy
        this.mean = obj.mean

        this.totalGames = obj?.totalGames
        this.totalWords = obj?.totalWords
        this.globalRank = obj?.globalRank
        this.countryRank = obj?.countryRank

        if (obj?.bestScoresByDay !== undefined) {
            this.bestScoresByDay = obj?.bestScoresByDay
                .map((data: any) => ({date: new Date(data.date), score: data.score}))    
        }

        if (obj?.positions !== undefined) {
            this.positions = obj?.positions
                .map((data: any) => (
                    {date: new Date(data.date), score: data.position, scoreUser: data.score, totalPlayers: data.count, avgWords: data.avgWords, topWords: data.topWords}
                )
            )
        }
        this.avgPosition = obj?.avgPosition
        this.rank = obj.rank
    }
}
